<template>

    <div id="layout-auth" class="layout">
        <v-the-alerts />
        <v-the-cookie-banner />
        <transition name="modal">
            <v-modal-cookie-preferences v-if="modal === 'cookie-preferences'" />
        </transition>
        <v-the-header />
        <div class="layout-body">
            <transition name="fade" mode="out-in">
                <router-view></router-view>
            </transition>
        </div>
        <v-the-footer />
    </div>

</template>

<style scoped lang="scss">

    .layout {
        background: $color-white;
        display: flex;
        flex-direction: column;
        min-height: 100%;
        .layout-body {
            align-items: center;
            display: flex;
            flex-grow: 1;
            padding: 30px 0;
            @media (max-width: map-get($grid-breakpoints, 'sm')) {
                padding: 15px 0;
            }
        }
    }

</style>

<script>

import ModalCookiePreferences from '@modals/ModalCookiePreferences';
import TheAlerts from '@cmp/TheAlerts';
import TheCookieBanner from '@cmp/TheCookieBanner';
import TheFooter from '@cmp/TheFooter';
import TheHeader from '@cmp/TheHeader';

export default {

    components: {
        'v-modal-cookie-preferences': ModalCookiePreferences,
        'v-the-alerts': TheAlerts,
        'v-the-cookie-banner': TheCookieBanner,
        'v-the-footer': TheFooter,
        'v-the-header': TheHeader,
    },

    computed: {

        modal() {
            return this.$store.getters.modal;
        },

    },

    beforeCreate() {
        if (!localStorage.getItem('lang')) {
            this.$store.commit('setTempLang');
        }
    },

    mounted() {
        const domain = window.location.hostname.toLowerCase().replace('www.', '');
        if (domain !== process.env.VUE_APP_DOMAIN && typeof window.Beacon === 'function') {
            window.Beacon('destroy');
            window.Beacon('on', 'ready', () => window.Beacon('destroy'));
        }
    },

}

</script>